
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hbQeG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lMGh1 = parcelRequire("lMGh1");


var $euL71 = parcelRequire("euL71");


var $jln20 = parcelRequire("jln20");


var $bQm3c = parcelRequire("bQm3c");


var $laFNM = parcelRequire("laFNM");


var $1vpkQ = parcelRequire("1vpkQ");


var $kWNKJ = parcelRequire("kWNKJ");

/* BannerComponent.tsx generated by @compiled/babel-plugin v0.40.0 */ 



var $jEK83 = parcelRequire("jEK83");


var $w6R6I = parcelRequire("w6R6I");


var $ad7Ou = parcelRequire("ad7Ou");


var $k75o7 = parcelRequire("k75o7");


var $bcDqz = parcelRequire("bcDqz");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $I7hWB = parcelRequire("I7hWB");


var $j3QkC = parcelRequire("j3QkC");

const $3738c5ea522320d3$var$styles = {
    wrapper: "_1yt4pxbi _2rko1qi0 _zulppxbi _bfhkhfxm _1e0c1txw _4cvr1h6o",
    iconWrapper: "_1yt41b66 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf",
    leftSection: "_zulpu2gc _16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bah1y6m _1ul9184x",
    leftSectionGrow: "_16jlkb7n",
    contentWrapper: "_1o9zkb7n _1ul9idpf _1nmz1hna",
    progressBarWrapper: "_16jl11wp _1o9zkb7n _i0dlf1ug _1ul968cl",
    actionWrapper: "_zulputpp _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o"
};
const $3738c5ea522320d3$var$AvatarAndCtaRenderer = ({ action: action, avatarData: avatarData })=>{
    const showAvatars = avatarData != null && avatarData.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $3738c5ea522320d3$var$styles.actionWrapper
    }, showAvatars && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
        data: avatarData,
        maxCount: 2,
        onMoreClick: (0, (/*@__PURE__*/$parcel$interopDefault($jEK83)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: action.onClick
    }, action.label));
};
const $3738c5ea522320d3$export$b7f0db819db4d29e = ({ heading: heading, description: description, showProgressBar: showProgressBar, icon: icon, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3738c5ea522320d3$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($3738c5ea522320d3$var$styles.leftSection, !showProgressBar && $3738c5ea522320d3$var$styles.leftSectionGrow)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3738c5ea522320d3$var$styles.iconWrapper
    }, icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k75o7))), {
        label: heading,
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $3738c5ea522320d3$var$styles.contentWrapper,
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, heading), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtlest"
    }, description))), showProgressBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3738c5ea522320d3$var$styles.progressBarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j3QkC.ApprovalsProgressBar), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3738c5ea522320d3$var$AvatarAndCtaRenderer, props));
};


const $8954bfaf7287379e$var$i18n = (0, $kSwu1.defineMessages)({
    approvalInProgressHeading: {
        id: "approvals.banner.approval-in-progress.heading",
        defaultMessage: "Approval in progress"
    },
    approvedDescription: {
        id: "approvals.banner.approved.description",
        defaultMessage: "{current}/{total} approved"
    },
    respondedDescription: {
        id: "approvals.banner.responded.description",
        defaultMessage: "{current}/{total} responded"
    },
    yourApprovalNeededHeading: {
        id: "approvals.banner.your-approval-needed.heading",
        defaultMessage: "Your approval is needed"
    },
    yourApprovalNeededByDueDateHeading: {
        id: "approvals.banner.your-approval-needed-by-due-date.heading.ai-non-final",
        defaultMessage: "Your approval is needed by {dueDate}"
    },
    approverRequestDescription: {
        id: "approvals.banner.approver-request.description",
        defaultMessage: "From {requestorName}: \"{reviewComment}\""
    },
    respondCta: {
        id: "approvals.banner.respond.cta",
        defaultMessage: "Respond"
    },
    editResponseCta: {
        id: "approvals.banner.edit-response.cta",
        defaultMessage: "Edit response"
    },
    viewDetailsCta: {
        id: "approvals.banner.view-details.cta",
        defaultMessage: "View details"
    },
    blockedApprovalHeading: {
        id: "approvals.banner.blocked-approval.heading",
        defaultMessage: "This approval needs attention."
    },
    seeDetailsCta: {
        id: "approvals.banner.see-details.cta",
        defaultMessage: "See details"
    }
});
const $8954bfaf7287379e$export$9e2285f96d44792b = ()=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { approvalRequest: approvalRequest, approvalRequestLoading: approvalRequestLoading, currentUserApprover: currentUserApprover, contentId: contentId, contentStatus: contentStatus, isContentApprovalsEnabled: isContentApprovalsEnabled, isCurrentUserRequestor: isCurrentUserRequestor, isPendingReviewBlockedByRequiredApproversChange: isPendingReviewBlockedByRequiredApproversChange } = (0, $laFNM.useApprovals)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const openApprovalsPane = (0, $cozmU.useCallback)(()=>{
        (0, $1vpkQ.openApprovalsPaneForContext)({
            contentId: contentId,
            contentStatus: contentStatus,
            rightSidebarContext: rightSidebarContext
        });
    }, [
        contentId,
        contentStatus,
        rightSidebarContext
    ]);
    const approvers = approvalRequest?.review?.approvers;
    const avatarData = (0, $cozmU.useMemo)(()=>{
        if (!approvers?.length) return [];
        // Sort approvers by status, so that approvers that denied are shown first
        const statusOrder = {
            REVIEWER_DENIED: 0,
            REVIEWER_APPROVED: 1
        };
        const defaultOrder = 2; // PENDING_REVIEW and any other statuses come last
        const sorted = [
            ...approvers
        ].sort((a, b)=>(statusOrder[a.status] ?? defaultOrder) - (statusOrder[b.status] ?? defaultOrder));
        // Convert approvers to AvatarProps for a presentational AvatarGroup
        return sorted.map((approver)=>{
            let status;
            if (approver.status === 'REVIEWER_APPROVED') status = 'approved';
            else if (approver.status === 'REVIEWER_DENIED') status = 'declined';
            return {
                appearance: 'circle',
                src: approver.avatarUrl || '',
                name: undefined,
                size: 'small',
                status: status
            };
        });
    }, [
        approvers
    ]);
    const { responseCount: responseCount, hasDenials: hasDenials } = (0, $cozmU.useMemo)(()=>{
        let approvedCount = 0;
        let deniedCount = 0;
        for (const a of approvers ?? []){
            if (a.status === 'REVIEWER_APPROVED') approvedCount++;
            else if (a.status === 'REVIEWER_DENIED') deniedCount++;
        }
        return {
            responseCount: approvedCount + deniedCount,
            hasDenials: deniedCount > 0
        };
    }, [
        approvers
    ]);
    const formattedDueDate = (0, $cozmU.useMemo)(()=>{
        const dueDate = approvalRequest?.review?.dueDate;
        if (!dueDate) return null;
        const date = (0, $kWNKJ.getNoonUtcDateFromDateOnly)(dueDate);
        if (!date) return null;
        return formatDate(date, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            timeZone: 'UTC'
        });
    }, [
        approvalRequest?.review?.dueDate,
        formatDate
    ]);
    // Don't render for non-premium editions, when space-level approvals are disabled,
    // or if loading, no review, or review is not pending
    if (edition !== (0, $euL71.ConfluenceEdition).PREMIUM) return null;
    if (!isContentApprovalsEnabled) return null;
    if (approvalRequestLoading) return null;
    if (!approvalRequest?.review) return null;
    if (approvalRequest.review.reviewStatus !== 'PENDING') return null;
    const isApproverPendingResponse = currentUserApprover?.status === 'PENDING_REVIEW';
    const isApproverResponded = currentUserApprover != null && currentUserApprover.status !== 'PENDING_REVIEW';
    // Description text: "X/Y approved" when no denials, "X/Y responded" when there are denials
    const progressDescription = formatMessage(hasDenials ? $8954bfaf7287379e$var$i18n.respondedDescription : $8954bfaf7287379e$var$i18n.approvedDescription, {
        current: responseCount,
        total: approvers?.length ?? 0
    });
    if (isPendingReviewBlockedByRequiredApproversChange) {
        if (!isCurrentUserRequestor && !currentUserApprover) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3738c5ea522320d3$export$b7f0db819db4d29e), {
            heading: formatMessage($8954bfaf7287379e$var$i18n.blockedApprovalHeading),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
                label: formatMessage($8954bfaf7287379e$var$i18n.blockedApprovalHeading),
                color: "var(--ds-icon-warning, #E06C00)"
            }),
            action: {
                type: 'button',
                label: formatMessage($8954bfaf7287379e$var$i18n.seeDetailsCta),
                onClick: openApprovalsPane
            }
        });
    }
    // Approver who hasn't responded
    if (isApproverPendingResponse) {
        const reviewComment = approvalRequest.review.reviewComment || '';
        const requestorName = approvalRequest.review.requestorName || '';
        const hasReviewComment = Boolean(reviewComment);
        const heading = formattedDueDate ? formatMessage($8954bfaf7287379e$var$i18n.yourApprovalNeededByDueDateHeading, {
            dueDate: formattedDueDate
        }) : formatMessage($8954bfaf7287379e$var$i18n.yourApprovalNeededHeading);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3738c5ea522320d3$export$b7f0db819db4d29e), {
            heading: heading,
            description: hasReviewComment ? formatMessage($8954bfaf7287379e$var$i18n.approverRequestDescription, {
                requestorName: requestorName,
                reviewComment: reviewComment
            }) : progressDescription,
            avatarData: hasReviewComment ? undefined : avatarData,
            action: {
                type: 'button',
                label: formatMessage($8954bfaf7287379e$var$i18n.respondCta),
                onClick: openApprovalsPane
            },
            showProgressBar: !hasReviewComment
        });
    }
    // Approver who has responded, or Requestor/Viewer
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3738c5ea522320d3$export$b7f0db819db4d29e), {
        heading: formatMessage($8954bfaf7287379e$var$i18n.approvalInProgressHeading),
        description: progressDescription,
        avatarData: avatarData,
        action: {
            type: 'button',
            label: formatMessage(isApproverResponded ? $8954bfaf7287379e$var$i18n.editResponseCta : $8954bfaf7287379e$var$i18n.viewDetailsCta),
            onClick: openApprovalsPane
        },
        showProgressBar: true
    });
};
module.exports["ApprovalBanner"] = $8954bfaf7287379e$export$9e2285f96d44792b;

});

parcelRegister("k75o7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::177057641801787c460d2f596e29ad78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea48a40f0e744b32$var$_react = $ea48a40f0e744b32$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ea48a40f0e744b32$var$_baseNew = $ea48a40f0e744b32$var$_interopRequireDefault((parcelRequire("gElAV")));
function $ea48a40f0e744b32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowInReview".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing statuses that signal consideration, assessment, and review
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ea48a40f0e744b32$var$StatusWorkflowInReviewIcon = (props)=>/*#__PURE__*/ $ea48a40f0e744b32$var$_react.default.createElement($ea48a40f0e744b32$var$_baseNew.default, Object.assign({
        name: "StatusWorkflowInReviewIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8 3a5 5 0 1 1-5 5h5z"/><path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5V0a8 8 0 1 1-8 8z"/><path fill="currentcolor" d="m.812 7.053.743.097A7 7 0 0 0 1.5 8H0q0-.53.067-1.044zm2.03-3.01c-.343.447-.63.94-.849 1.469L.607 4.938a8 8 0 0 1 1.046-1.81zm2.67-2.05a6.5 6.5 0 0 0-1.469.85l-.914-1.19A8 8 0 0 1 4.938.607zM8 1.5q-.433 0-.85.055L7.053.812 6.956.067Q7.47.001 8 0z"/>`
    }, props));
$ea48a40f0e744b32$var$StatusWorkflowInReviewIcon.displayName = 'StatusWorkflowInReviewIcon';
var $ea48a40f0e744b32$var$_default = module.exports.default = $ea48a40f0e744b32$var$StatusWorkflowInReviewIcon;

});

parcelRegister("j3QkC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $laFNM = parcelRequire("laFNM");


var $f43UY = parcelRequire("f43UY");

const $98505e88072c3ce6$var$countByStatus = (approvers)=>approvers.reduce((counts, approver)=>{
        if (approver.status === 'REVIEWER_APPROVED') counts.approved++;
        else if (approver.status === 'REVIEWER_DENIED') counts.denied++;
        counts.total++;
        return counts;
    }, {
        approved: 0,
        denied: 0,
        total: 0
    });
const $98505e88072c3ce6$var$i18n = (0, $kSwu1.defineMessages)({
    approvedLabel: {
        id: "approvals.progress-bar.approved-label",
        defaultMessage: "{count} approved"
    },
    deniedLabel: {
        id: "approvals.progress-bar.denied-label",
        defaultMessage: "{count} denied"
    },
    ariaLabel: {
        id: "approvals.progress-bar.aria-label",
        defaultMessage: "Approvals progress"
    }
});
const $98505e88072c3ce6$export$b67a8dfe7ce21df4 = ()=>{
    const { approvalRequest: approvalRequest } = (0, $laFNM.useApprovals)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const approvers = approvalRequest?.review?.approvers;
    const { approved: approved, denied: denied, total: total } = (0, $cozmU.useMemo)(()=>$98505e88072c3ce6$var$countByStatus(approvers ?? []), [
        approvers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f43UY.MultiColorProgressBar), {
        segments: [
            {
                count: approved,
                color: "var(--ds-icon-success, #6A9A23)",
                label: formatMessage($98505e88072c3ce6$var$i18n.approvedLabel, {
                    count: approved
                })
            },
            {
                count: denied,
                color: "var(--ds-icon-accent-gray, #7D818A)",
                label: formatMessage($98505e88072c3ce6$var$i18n.deniedLabel, {
                    count: denied
                })
            }
        ],
        total: total,
        ariaLabel: formatMessage($98505e88072c3ce6$var$i18n.ariaLabel)
    });
};
module.exports["ApprovalsProgressBar"] = $98505e88072c3ce6$export$b67a8dfe7ce21df4;

});

parcelRegister("f43UY", function(module, exports) {
/* MultiColorProgressBar.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");

const $41481707d81a074d$var$borderRadius = "var(--ds-radius-small, 4px)";
const $41481707d81a074d$var$defaultBarColor = "var(--ds-background-neutral-bold, #292A2E)";
const $41481707d81a074d$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
    segment: "_v5641lap _1e0c1ule _4t3ii2wt _kqswstnw"
};
const $41481707d81a074d$var$getSegmentBorderRadius = (isFirst, isLast)=>{
    if (isFirst && isLast) return $41481707d81a074d$var$borderRadius;
    if (isFirst) return `${$41481707d81a074d$var$borderRadius} 0 0 ${$41481707d81a074d$var$borderRadius}`;
    if (isLast) return `0 ${$41481707d81a074d$var$borderRadius} ${$41481707d81a074d$var$borderRadius} 0`;
    return '0';
};
const $41481707d81a074d$export$6fe94d7699460647 = ({ segments: segments, total: total, ariaLabel: ariaLabel, testId: testId = 'multi-color-progress-bar' })=>{
    const clampedTotal = Math.max(total, 0); // Precalculate segments
    const segmentLayout = (0, $cozmU.useMemo)(()=>{
        const activeIndices = segments.reduce((set, segment, index)=>{
            if (segment.count > 0) set.add(index);
            return set;
        }, new Set());
        let cumulative = 0;
        let activeIndex = 0;
        const activeCount = activeIndices.size;
        return segments.map((segment, index)=>{
            const isActive = activeIndices.has(index);
            const widthPercent = isActive && clampedTotal > 0 ? segment.count / clampedTotal * 100 : 0;
            const leftPercent = cumulative;
            cumulative += widthPercent;
            const isFirstActive = isActive && activeIndex === 0;
            const isLastActive = isActive && activeIndex === activeCount - 1;
            const gap = isActive && !isFirstActive ? 1 : 0;
            if (isActive) activeIndex++;
            return {
                widthPercent: widthPercent,
                leftPercent: leftPercent,
                color: segment.color,
                label: segment.label,
                isFirst: isFirstActive,
                isLast: isLastActive,
                gap: gap
            };
        });
    }, [
        segments,
        clampedTotal
    ]);
    // Used only for aria-valuenow
    const totalCount = (0, $cozmU.useMemo)(()=>segmentLayout.reduce((sum, segment)=>sum + segment.widthPercent, 0), [
        segmentLayout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": 0,
        "aria-valuenow": clampedTotal > 0 ? Math.round(totalCount / 100 * clampedTotal) : 0,
        "aria-valuemax": clampedTotal,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $41481707d81a074d$var$styles.container
        ])
    }, clampedTotal > 0 && segmentLayout.map((layout, index)=>{
        const segment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: {
                left: `calc(${layout.leftPercent}% + ${layout.gap}px)`,
                width: `calc(${layout.widthPercent}% - ${layout.gap}px)`,
                backgroundColor: layout.color ?? $41481707d81a074d$var$defaultBarColor,
                borderRadius: $41481707d81a074d$var$getSegmentBorderRadius(layout.isFirst, layout.isLast)
            },
            "data-testid": `${testId}--segment-${index}`,
            className: (0, $hekY6.default)([
                $41481707d81a074d$var$styles.segment
            ])
        });
        return layout.label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: index,
            content: layout.label
        }, segment) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: index
        }, segment);
    }));
};
module.exports["MultiColorProgressBar"] = $41481707d81a074d$export$6fe94d7699460647;

});


//# sourceMappingURL=ApprovalBanner.fd8969d7.js.map
